// Campus photo for /colleges/indiana-university-bloomington: CC BY 2.0, by IT Communications Office, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3ASample_Gates%2C_Indiana_University_Bloomington%2C_2010.jpg), checked 2026-10-01 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/indiana-university-bloomington/; credited under the photo.
const photo = {
    "slug": "indiana-university-bloomington",
    "alt": "The Sample Gates at the entrance to the Indiana University Bloomington campus, with a clock tower beyond them",
    "src": "/colleges/indiana-university-bloomington/campus-1600.webp",
    "srcSmall": "/colleges/indiana-university-bloomington/campus-800.webp",
    "srcMid": "/colleges/indiana-university-bloomington/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/indiana-university-bloomington/og.jpg",
    "title": "Sample Gates, Indiana University Bloomington, 2010",
    "author": "IT Communications Office",
    "license": "CC BY 2.0",
    "licenseUrl": "https://creativecommons.org/licenses/by/2.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3ASample_Gates%2C_Indiana_University_Bloomington%2C_2010.jpg",
    "read": "2026-10-01"
};

export default photo;
